module.exports = __webpack_public_path__ + "static/media/footer2.77948c37.jpg";